export default __webpack_public_path__ + "static/kathi-1ef5a7795c1871b84c79b16dc28083d0.png";